import Joi from 'joi';
import PropTypes from 'prop-types';

import Conditional from '../../common/conditional';
import Form from '../../common/form';

import { matchPhrases } from '../../../utils/utilities';
import { getStructureInspectionTypeOptions, getStructureNDESubTypeOptions } from '../../../utils/data';
import { StructureInspectionTypeEntry } from '../../../utils/models';

import toastService from '../../../services/toastService';

class StructureInspectionTypeForm extends Form {
	state = {
		data: {
			type: '',
			ndeSubType: '',
			description: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		type: Joi.string().required().label('Inspection Type'),
		ndeSubType: Joi.string().when('type', {
			is: 'NDE',
			then: Joi.string().required().label('NDE Sub Type'),
			otherwise: Joi.string().allow('').optional().label('NDE Sub Type'),
		}),
		description: Joi.string().min(3).required().label('Description'),
	};

	static propTypes = {
		onSave: PropTypes.func,
	};

	doSubmit = (): void => {
		const entry: Omit<StructureInspectionTypeEntry, 'id'> = {
			type: this.state.data.type as StructureInspectionTypeEntry['type'],
			ndeSubType: matchPhrases(this.state.data.type, 'NDE') ? this.state.data.ndeSubType as StructureInspectionTypeEntry['ndeSubType'] : '',
			description: this.state.data.description,
		};

		this.props.onSave(entry);

		this.setState({
			data: {
				type: '',
				ndeSubType: '',
				description: '',
			},
		});

		toastService.success('Inspection Type Added Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderSelect({
							name: 'type',
							placeholder: 'Select Inspection Type',
							label: 'Inspection Type',
							options: getStructureInspectionTypeOptions(),
						})}
					</div>

					<Conditional isVisible={matchPhrases(this.state.data.type, 'NDE')}>
						<div className="col">
							{this.renderSelect({
								name: 'ndeSubType',
								placeholder: 'Select NDE Sub Type',
								label: 'NDE Sub Type',
								options: getStructureNDESubTypeOptions(),
							})}
						</div>
					</Conditional>
				</div>

				<div className="my-4 divider"></div>

				{this.renderTextArea({
					name: 'description',
					placeholder: 'Enter Inspection Description',
					label: 'Description',
					rows: '4',
				})}

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Add Inspection Type')}
				</div>
			</form>
		);
	}
}

export default StructureInspectionTypeForm;
